/* global wpApiSettings */
/* eslint-disable func-names, prefer-arrow-callback, object-shorthand, no-param-reassign, max-len */
import $ from 'jquery';
import 'parsleyjs';
import datepicker from 'js-datepicker';

const $form = $( '.js-accountDateTimeChange-direct' );

function initDateTimeValidation() {
	const initialDate = $form.find( '#delivery-date' ).val();

	$form.parsley();

	$form.parsley().on( 'form:validate', function ( formInstance ) {
		const isNewDate = initialDate !== $form.find( '#delivery-date' ).val();
		formInstance.validationResult = false;

		if ( !isNewDate ) {
			$form.find( '.form-message' ).html( '<p class="ticketNotice ticketNotice--warning notNewDate">Please a new date</p>' );
		}

		if ( isNewDate ) {
			const dateTimeChangeDate = new FormData();
			dateTimeChangeDate.append( 'orderId', $form.attr( 'data-order-id' ) );
			dateTimeChangeDate.append( 'date', $form.find( '#delivery-date' ).val() );

			const settings = {
				url: `${wpApiSettings.root}cherryhill/v1/change_product_date_time`,
				method: 'POST',
				timeout: 0,
				processData: false,
				mimeType: 'multipart/form-data',
				contentType: false,
				data: dateTimeChangeDate,
			};

			if ( wpApiSettings.status ) {
				settings.beforeSend = xhr => xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			}

			$.ajax( settings )
				.done( ( response ) => {
					$form.find( '.form-message' ).html( `<p class="ticketNotice">${JSON.parse( response )}</p>` );
				} ).fail( () => {
					console.log( 'api date time change failed' );
				} );
		}
	} );
}

function validateDeliveryDate() {
	$form.find( '.notNewDate' ).remove();
	// $form.find( '.form-message' ).html( '<p class="ticketNotice">Sorry but that date is full</p>' );
}

function initDatePicker() {
	const datePicker = document.querySelector( '.accountDateTimeChange-fieldWrapper #delivery-date' );

	if ( !datePicker ) {
		return false;
	}

	const today = new Date();

	const tomorrow = new Date();
	tomorrow.setDate( today.getDate() + 1 );

	const theNextDay = new Date();
	theNextDay.setDate( today.getDate() + 2 );

	const picker = datepicker( datePicker, {
		position: 'br',
		minDate: today,
		startDate: today,
		maxDate: new Date( 2022, 0, 10 ),
		disabledDates: [
			today,
			tomorrow,
			theNextDay,
		],
		disabler: date => ( !( date.getDay() === 1 || date.getDay() === 3 ) ), // allow Tues & Mon
		onSelect: () => {
			validateDeliveryDate();
		},
		formatter: ( input, date ) => {
			const value = date.toLocaleDateString( 'en-au', { year: 'numeric', month: 'numeric', day: 'numeric' } );
			input.value = value;
		},

	} );

	return picker;
}

function init() {
	if ( !$form.length ) {
		return;
	}

	initDatePicker();
	initDateTimeValidation();
}

export default {
	init,
};
